// @ts-nocheck
import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { LoadingComponent } from '../../../../_old_general-components/loading/loading.component';
import { BodyFeedbackComponent } from '../../../body-feedback/body-feedback.component';
import { GridboxComponent } from '../../../fields/gridbox/gridbox.component';
import { TableListComponent } from '../../../fields/table-list/table-list.component';
import { DynamicFormService } from '../../dynamic-form.service';
import { ParallelTaskService } from './parallel-task.service';

@Component({
  selector: 'legalboxplus-parallel-tasks',
  templateUrl: './parallel-tasks.component.html',
  styleUrl: './parallel-tasks.component.scss',
  imports: [NgClass, GridboxComponent, LoadingComponent, TableListComponent, BodyFeedbackComponent],
  providers: [ParallelTaskService],
})
export class ParallelTasksComponent implements OnInit {
  public outputConfig: any = {};
  public tableListData: any = [];
  public data: any = {};
  public subFormModuleInstance: any;
  public gridFormModuleInstance: any;
  public atributesTask: any;
  public disabedControll!: boolean;
  public initialized!: boolean;
  public cardData: any = {};
  public cardInfo: any = {};
  public loadHistory!: boolean;
  public loaderButton = false;
  public parallelLines = [];
  public timeout: ReturnType<typeof setTimeout> | null = null;
  public isSendTask = true;
  public cleanUp: boolean = true;
  public isReadonly: boolean = false;

  @Input('config') set configurationTemplate(config: any) {
    const { isSendTask = true } = config;
    if (!isSendTask) {
      this.isSendTask = config.isSendTask;
    }
    this.outputConfig = config;
  }

  @Input('dataAttr') set dataAttibutes(data) {
    this.atributesTask = data;
  }
  public flowId;
  @Input('flowId') set flow(id) {
    this.flowId = id;
  }
  @Input('subFormModuleInstance') set subFormModuleInstanceController(fn) {
    this.subFormModuleInstance = fn;
  }
  @Input('gridFormModuleInstance') set gridFormModuleInstanceController(fn) {
    this.gridFormModuleInstance = fn;
  }
  @Input('disabled') set disabledSetter(status: boolean) {
    this.disabedControll = status;
  }
  @Input('initialized') set initializedValue(initialized: boolean) {
    this.initialized = initialized;
  }
  @Input('cardInfo') set cardinfoSetter(card) {
    this.cardInfo = card;
  }
  @Input('metadata') set metadataSetter(metadata) {
    this.cardData.context = metadata.entityKey;
  }
  @Input() dynamicFormService!: DynamicFormService;

  constructor(private service: ParallelTaskService) {}

  ngOnInit(): void {
    this.getHistory();
  }

  public changeValue(value: any) {
    const params = {
      context: this.outputConfig.entityKey,
      processId: this.atributesTask.processNumber,
      taskId: this.cardInfo.id,
    };
    if (value.length >= this.parallelLines.length) {
      this.parallelLines = value;
    } else {
      const diffVal = this.parallelLines.filter(
        ({ id: id1 }) => !value.some(({ id: id2 }) => id2 === id1)
      );
      diffVal.forEach((el) => {
        const delParams = {
          id: el?.['id'],
        };
        this.service.delParallelRequest(delParams).subscribe();
      });
    }

    this.loaderButton = true;

    this.service.postRequestTask(value, params).subscribe((resp) => {
      this.loaderButton = false;
    });
  }

  public sendParallelRequests() {
    if (this.loaderButton) {
      return;
    }
    this.loaderButton = true;
    const params = {
      context: this.outputConfig.entityKey,
      processId: this.atributesTask.processNumber,
      taskId: this.cardInfo.id,
    };

    this.service.sendParallelRequests(params).subscribe(
      (resp) => {
        this.getHistory();
        this.loaderButton = false;
        this.cleanUp = !this.cleanUp;
      },
      () => {
        this.loaderButton = false;
        this.cleanUp = !this.cleanUp;
      }
    );
  }

  private getHistory() {
    this.loadHistory = false;
    this.isReadonly = this.outputConfig.readonly;
    const params = {
      context: this.outputConfig.entityKey,
      processId: this.atributesTask.processNumber,
    };
    this.service.getParallelHistory(params).subscribe((resp) => {
      if (resp.pending) {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.getHistory(), 2000);
      } else {
        this.tableListData = resp;
        if (this.tableListData.length) {
          this.loadHistory = true;
        }
      }
    });
  }
}
